import type {
	Currency$options,
	DistanceSystem$options,
	ItineraryConstraint$options,
	ItineraryTrafficMode$options,
	ItineraryTravelMode$options,
} from '$houdini';
import { getDefaultTripOptions, type TripOptionCar } from '$lib/components/itinerary/tripOptions';
import { getSearchParamsStore } from '$lib/services/urls/searchParams';

import { get, type Writable, writable } from 'svelte/store';

export interface TripOptions {
	travelMode: ItineraryTravelMode$options;
	tripConstraint: ItineraryConstraint$options;
	distanceSystem: DistanceSystem$options;
	currency: Currency$options;
	energyPrice?: number;
	car?: TripOptionCar;
	isElectricVehicle?: boolean;
	rechargeTreshold?: number;
	withCaravan?: boolean;
	traffic?: ItineraryTrafficMode$options;
}

export function createTripOptionsStore(): Writable<TripOptions> {
	const searchParamsStore = getSearchParamsStore();
	const defaultOptions = getDefaultTripOptions();
	const searchParams = get(searchParamsStore);
	// Get default value from searchParams in case user go back to iti search from iti results and reloads the page
	return writable<TripOptions>({
		travelMode: searchParams.travelMode ?? defaultOptions.travelMode,
		tripConstraint: searchParams.tripConstraint ?? defaultOptions.tripConstraint,
		distanceSystem: searchParams.distanceSystem ?? defaultOptions.distanceSystem,
		currency: searchParams.currency ?? defaultOptions.currency,
		energyPrice: searchParams.energyPrice ?? defaultOptions.energyPrice,
		car: searchParams.car ?? undefined,
		rechargeTreshold: searchParams.rechargeTreshold ?? defaultOptions.rechargeTreshold,
		withCaravan: searchParams.withCaravan ?? undefined,
		traffic: searchParams.traffic ?? defaultOptions.traffic,
	});
}

export type TripOptionsStore = ReturnType<typeof createTripOptionsStore>;
